import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CreateView from "@/views/Category/CreateView";
import ListView from "@/views/Category/ListView";
import AccountView from "@/views/Setting/AccountView";
import DataAnalysis from "@/views/DataAnalysis";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/category-create',
    name: 'category-create',
    component: CreateView
  },
  {
    path: '/category-lists',
    name: 'category-lists',
    component: ListView
  },
  {
    path: '/profile',
    name: 'profile',
    component: AccountView,
  },
  {
    path: '/Data-Analysis',
    name: 'data-analysis',
    component: DataAnalysis
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active',
})

export default router
